<template>
  <el-dialog
    :title="`${actionIndex ? 'Edit' : 'New'} Discography`" :model-value="flagVisible" width="30%"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="discography" label-position="top" size="small">
      <el-form-item>
        <el-input v-model="discography.artist" placeholder="Artist"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="discography.song" placeholder="Song"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="discography.producer_engineer" placeholder="Producer/Engineer"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="discography.instruments" placeholder="Instruments"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="discography.spotify_link" placeholder="Spotify Link"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="discography.tidal_link" placeholder="TIDAL Link"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" @click="handleClose">CANCEL</el-button>
        <el-button size="small" class="el-btn-blue" :loading="flagLoading.save" @click="updateData">SAVE</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
export default {
  props: {
    flagVisible: Boolean,
    actionIndex: Number,
    actionItem: Object
  },
  emits: ['closeModal', 'updateData'],
  data: function () {
    const flagLoading = reactive({
      save: false
    })
    return {
      discography: this.actionItem,
      flagLoading
    }
  },
  created: function () {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        this.discography = val
      },
      deep: true
    }
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    },
    updateData: function () {
      this.$emit('updateData', this.actionIndex, this.discography)
    }
  }
}
</script>

<style scoped lang="scss">
</style>
